// Fetch and process customer queries and website messages from the backend

import { createContext, useContext, useState } from 'react';
import api from '../services/api';

const QueryContext = createContext();

export const useQuery = () => useContext(QueryContext);

export const QueryProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [customerQueries, setCustomerQueries] = useState([]);
    const [websiteMessages, setWebsiteMessages] = useState([]);

    const fetchCustomerQueries = async () => {
        try {
            const response = await api.get('/customer-query/');
            if (response.status === 200) {
                const response_data = response.data;
                let data = [];
                if (response_data && response_data.success) {
                    data = response_data.data || [];
                } else if (Array.isArray(response_data)) {
                    data = response_data;
                }
                setCustomerQueries(data);
                return data;
            } else {
                setError(response.data.details);
            }
        } catch (error) {
            setError(error.response?.data?.details || error.message);
        } finally {
            setLoading(false);
        }
    }

    const fetchWebsiteMessages = async () => {
        try {
            const response = await api.get('/website-contact-messages/list/');
            if (response.status === 200) {
                const response_data = response.data;
                let data = [];
                if (response_data && response_data.success) {
                    data = response_data.data || [];
                } else if (Array.isArray(response_data)) {
                    data = response_data;
                }
                setWebsiteMessages(data);
                return data;
            } else {
                setError(response.data.details);
            }
        } catch (error) {
            setError(error.response?.data?.details || error.message);
        } finally {
            setLoading(false);
        }
    }

    const updateQueryStatus = async (queryId, remarks, status) => {
        try {
            const response = await api.put(`/customer-query/${queryId}/query/`, {
                status: status,
                remarks: remarks
            });
            return response;
        } catch (error) {
            setError(error.response?.data?.details || error.message);
            throw error;
        }
    }

    const value = {
        customerQueries,
        websiteMessages,
        loading,
        error,
        fetchCustomerQueries,
        fetchWebsiteMessages,
        updateQueryStatus
    };

    return (
        <QueryContext.Provider value={value}>
            {children}
        </QueryContext.Provider>
    );
}

export default QueryContext;
